import { PackageDetailsModal } from './package-details-modal';

export default PackageDetailsModal;
